const config = Object.freeze({
  /* ================================STAGING BUILD================================== */
  // baseUrl: "https://sfastaging.nyggs.com/backend/", // staging build
  // baseUrl: "https://sfastagingbbsr.nyggs.com/backend/", // sfa staging build BBSR
  // baseUrl: "http://192.168.60.249:8080/watsoo/",
  // baseUrl: "http://192.168.12.66:8080/watsoo/",
  // baseUrl: "http://192.168.12.67:8080/watsoo/",
  // baseUrl: "http://192.168.12.3:8080/watsoo/",
  // baseUrl: "http://192.168.12.43:8080/watsoo-sfa/",
  // baseUrl: "http://192.168.12.57:8080/watsoo/",
  // baseUrl: "http://staging.watsoo.com:8085/watsoo/",
  // baseUrl: "http://staging.watsoo.com:8085/sfa-track-staging/",
  // baseUrl: "http://192.168.30.41:8085/sfa-track-staging/",
  // baseUrl: "http://192.168.30.33:8080/gps_sfa/",

  // baseUrl:"http://192.168.60.193:8080/watsoo/",
  // baseUrl:"http://localhost:8087/watsoo/",

  // baseUrl: "http://192.168.200.21:8080/watsoo-sfa-test/",

  /* ==================================END========================================= */

  /* ================================PRODUCTION BUILD================================== */
  //
  baseUrl: "https://sfa.nyggs.com/livebackend/",
  // baseUrl: "https://gps-manufacturing.nyggs.com/backend/",
  apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw",
  /* ==================================END========================================= */

  /* ================================STAGING BUILD================================== */
  // baseUrl: "http://192.168.60.193:8080/watsoo/",
  // apiKey: "AIzaSyA5Lt3E5gYb-lfogvaSpCrvCpocLqHwNOI",

  /* ================================STAGING BUILD  OderManagement================================== */
  // baseUrlForOderManagement: "https://sfaordersstaging.nyggs.com/",
  // baseUrlForOderManagement: "https://ordersstagingbbsr.nyggs.com/", // order management staging build BBSR
  // baseUrlForOderManagement: "http://192.168.12.49:3000/",

  /* ================================PRODUCTION BUILD  OderManagement================================== */
  // baseUrlForOderManagement: "https://gpsorders-manufacturing.nyggs.com/",
  baseUrlForOderManagement: "https://sfaorders.nyggs.com/",

  /* ==================================END========================================= */
  //http://localhost:8085/watsoo/client_communicatin/v1/get/all/hrms.cc/history

  version: "24.13",
  apiName: {
    login: "v2/watsoo/login/hrms",
    //userInfo: "v1/watsoo/all/hrms/userInfo",
    userInfo: "v3/watsoo/all/hrms/userInfo",
    userList: "outwork/hrmsuserLists",
    distance: "client_communicatin/v3/get/all/od/distance",
    summaryReport: "client_communicatin/v3/get/all/od/distance",
    client_communicatin:
      "client_communicatin/v1/get/all/od/distance/for/dashboard",
    // clientDetails: "v3/watsoo/fetchVendorListForHrms",
    clientDetails: "v3/watsoo/fetchVendorListForHrms/pagination",

    TeamList: "client_communicatin/v1/watsoo/all/hrms/manager",
    ScheduledMeting: "client_communicatin/v1/get/all/communication/follow/up",
    ScheduledMetingFordashboard:
      "client_communicatin/v1/get/all/communication/follow/up/for/dashboard",
    hrmsFilterData: "client_communicatin/v1/get/all/hrms.cc/history",
    showcompanyBaseHeader:
      "client_communicatin/v1/get/company/meeting/distance/logic",
    // expenseListGet: "client_communicatin/v2/get/all/user/expense",
    expenseListGet: "client_communicatin/v3/get/all/user/expense",
    expenseType: "client_communicatin/v1/get/all/expense/type",
    expensestatus: "client_communicatin/v2/update/user/expense/status",
    companyAndUsers: "client_communicatin/v1/get/hrms/company/and/user",
    userApprover: "client_communicatin/v1/save/user/expense/approver",
    showApprover: "client_communicatin/v1/get/user/expense/approver",
    getAllApprover: "client_communicatin/v1/get/user/expense/approver",
    deleteAppover: "client_communicatin/v1/update/user/expense/approver",
    configuration_details:
      "client_communicatin/v1/get/company/all/configuration/details",
    reassignedUser: "client_communicatin/v1/reassigned/communication/follow/up",
    companyWiseUpdate: "configuration_controller/v1/get/company/configuration",
    companyCongigurationData:
      "configuration_controller/v1/save/company/configuration",
    attendenceconfigurationList:
      "configuration_controller/v1/get/user/attendence/configuration",
    geofenceconfiguration:
      "configuration_controller/v1/get/user/od/on/off/geofence/configuration",
    companyclientstatus: "client_status/v1/save/company/client/status",
    clientstatusmaster: "client_status/v1/get/company/client/status/master",
    deletecompanyclientstatus: "client_status/v1/delete/company/client/status",
    updatecompanyclientstatus: "client_status/v1/update/company/client/status",
    updateclientstatus: "client_communicatin/v1/update/client/status",
    saveTempalte: "save/templateMaster/data",
    getSaveTempalte: "get/template/data",
    getTemplateTypeListByTypeId: "get/all/sub/customForm/type/by/typeId",
    getActiveInActiveTemplateTypeListByTypeId:
      "get/all/active-inactive/sub/customForm/type/by/typeId",
    saveTemplateType: "save/sub/templateType/data",
    // createcommunication:"client_communicatin/v4/create_communication"
    createcommunication: "v3/watsoo/saveVendorDetailsForHrms",
    CityList: "v1/watsoo/cityList",
    stateList: "v2/watsoo/stateList",
    countryList: "v1/watsoo/countrylist",
    getAddressFromGoogleMap: "get/address/from/googlemap",
    companyHeader: "header/get/company/header/details",
    headerUpdate: "header/update/company/header/details",
    updateCompanyById: "client_communicatin/v1/update/user/permission",
    liveTracking: "v1/get/user/instant/location/history",
    ImportClient: "v1/watsoo/importVendorDetailsForHrms",
    localityList: "localities/get/dropdown",
    orderPermissionListByUser:
      "configuration_controller/v1/get/sfa/user/sales/permission",
    allOrderPermissionList:
      "configuration_controller/v1/get/all/sfa/user/sales/permission",
    savePermissionForUser:
      "configuration_controller/v1/save/sfa/user/sales/permission",
    removePermissionForUser:
      "configuration_controller/v1/remove/sfa/user/sales/permission",
    getCompanyWiseUser:
      "client_communicatin/v1/get/hrms/company/and/user/by/companyid",
    getUserPermissionByUserId:
      "configuration_controller/v1/get/sfa/client/add/update/permission",
    getAllPermission:
      "configuration_controller/v1/get/all/sfa/client/add/update/permission",
    getWhatsappConfiguration: "get/company/whatsapp/configuration",
    saveWhatsappMaxMessageLimit: "set/company/wise/max/message/limit",
    getCompanywiseWhatsappMessageCount: "get/company/wise/message/count",
    getAllBankDetailsByCompany: "get/all/bank/details",
    saveBankDetailsByCompany: "save/bank/details",
    getCameraEnabledPages: "get/all/camera/enabled/pages",
    getCameraConfigDataForPage: "get/company/camera/config/data",
    getCameraTypes: "get/camera/type",
    saveCameraConfig: "save/company/camera/config/data",
    saveDefaultMeetingPermissionUserWise:
      "enable/userwise/default/metting/permission",
    getUserListByCompanyIdForDefaultMeeting: "get/user/list/by/company/id",
    restoreOdForUser: "client_communicatin/restore/today/od",
    restoreDeviceForUser: "client_communicatin/restore/today/device/login",
    getAllOrderManagementHeader: "get/dynamic/header/list",
    saveOrderDynamicHeader: "save/order/dynamic/header",
    multiLevelApproverByCompanyId: "get/approver/list",
    saveMultiLevelApproverByCompanyId: "save/company/wise/approver/list",
    deleteMultiLevelApproverByCompanyId: "delete/company/wise/approver/list",
    getAllOrderManagementPage: "get/all/pages",
    getAllMultiLevelApproverForCompanyDetails:
      "client_communicatin/v2/get/user/expense/approver",
    getAllMultiLevelApproverForCompanyDetailsV3:
      "client_communicatin/v3/get/user/expense/approver",
    getAllActiveInActiveUsers: "get/all/active/inactive/users",
    setActiveInActiveUsers: "change/user/activation/status",
    saveUndertakingForm: "company/undertaking/save",
    getUndertakingByCompanyId: "company/undertaking/getby/hrms/company/id",
    getAllUndertakingFormsByCompanyId:
      "company/undertaking/get/all/hrms/company/id",
    getDepartmentConfigurationByCompanyId:
      "company/department/configruration/getby/hrms/company/id",
    saveDepartmentConfiguration: "company/department/configruration/save",
    getHrmsUsers: "outwork/get/hrmsuserList",
    saveNotificationConfiguration:
      "configuration_controller/v1/save/company/notification/configuration",
    saveNotificationConfigurationForShiftCompletion:
      "configuration_controller/v1/save/company/notification/shift/configuration",
    getGeofenceDistanceByCompany:
      "configuration_controller/v1/sfa/company/local-geofence",
    saveGeofenceDistanceByCompany:
      "configuration_controller/v1/save/company/local-geofence",
    hrmsUserList: "get/hrms/user/list",
    updateUserLoginPermission: "update/user/login/permission",
    updateUserConvenseRatePermission: "v1/update/user/convense/rate/permission",
    getVendorsVehiclesDetailsById:
      "v1/watsoo/fetchVendorVehiclesDetailById/ftl",
    saveClientAddress: "v1/watsoo/saveClientAddress",
    updateClientAddress: "v1/watsoo/updateClientAddress",
    uploadFile: "client_communicatin/v1/get/user/expense/file/url",
    getDistanceThroughCoordinates: "get/distance",
    exportExpenseExcel: "client_communicatin/export/all/user/expense/excel",
    syncThirdPartyApi: "client/data/sync/api/save",
    getApiDataSync: "client/data/sync/api/getall",
    exportSummaryRportExcelBlob:
      "client_communicatin/export/meeting/list/excel",
    exportEmpWiseReportExcelBlob:
      "client_communicatin/export/meeting/list/employee/wise/excel",
    getVendorListForDropDown: "v1/get/vendorlist/drop/down",
    getAllModules: "get/all/module",
    getAllCompanyWiseAds: "get/all/ads/web",
    saveCompanyWiseAds: "save/company/wise/ads",
    getAllCompanyWiseSite: "company/department/configruration/get/all/sites",
    importScheduledMeeting:
      "client_communicatin/v1/save/list/communication/follow/up",
    getOdRestorationEmployeeList: "od/restoration/permission/get",
    odRestorationPermissionUpdate: "od/restoration/permission/update",
    restoreOd: "client_communicatin/restore/today/od",
    exportUser: "outwork/export/hrmsuserList/excel",
    getAllUserAccessPermissions: "user/access/permission/get",
    saveUsersAccessPermissions: "user/access/permission/save",

    // geofence endpoints
    getGeofenceList: "get/all/geofence",
    getGeofenceById: "get/geofence",
    addGeofence: "v1/add/geofence",
    updateGeofence: "v1/update/geofence",
    deleteGeofence: "",
    getGeofencesTrailData: "v1/user/get/all/geofence/trail-data",

    refreshCache: "v1/refresh/dashboard",

    userSites: "site-configuration/v1/get/all/user/site/config",
    saveUserSites: "site-configuration/v1/save/update/user/site/config",
    defaultMeetingVisitDetails:
      "out-of-location-visit/v1/get-location-visit-detail",
    saveVehicleType: "out-of-location-visit/v1/add-update/visit-vehicle-type",
    getVehicleTypeList: "out-of-location-visit/v1/getAll-vehicle-type",

    getRouteMode: "route-modes/v1/get-all/directions-mode",
    updateUserRouteMode: "route-modes/v1/add-update/user-wise/direction-mode-mapping",

    getGpsLost: "client_communicatin/v1/get/gps/location/status",
  },
});

export default config;
